import { useQuery } from 'react-query';

import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';
import { GET_PROPERTIES_PATH } from 'src/services/api/properties/constants';
import type { ITouringHours } from 'src/services/api/touring-hours/types';

type IPropertyTouringHoursResponse = {
    touring_hours: ITouringHours;
};

/**
 * Effective (inheritance-aware) touring hours for a property, read via the
 * property detail endpoint — there is no standalone GET touring-hours API.
 */
export function useTouringHours(propertyId?: number | null) {
    return useQuery(
        [queryKeys.touringHours, propertyId],
        async () => {
            const res = await apiClient(
                `${GET_PROPERTIES_PATH}/${propertyId}`,
                { searchParams: { include_touring_hours: '1' } },
            ).json<IPropertyTouringHoursResponse>();
            return res.touring_hours;
        },
        { enabled: propertyId != null }
    );
}
